import toast from "react-hot-toast";
import * as types from "./actionTypes";
import { apiLoadingStart, apiLoadingStop } from "../../../../../Store/global";
import ApiList from "../webservice/ApiList";

export const resetStore = () => ({
  type: types.RESET_STORE_USER,
});


export const getConsolidatedAction = () => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.GET_CONSOLIDATED_REQUEST });

    try {
      const response = await ApiList.getConsolidated();
      // console.log('getConsolidatedAction',response)
      if (response) {
        dispatch({
          type: types.GET_CONSOLIDATED_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({ type: types.GET_CONSOLIDATED_ERROR, payload: response.status });
      }
    } catch (error) {
      dispatch({
        type: types.GET_CONSOLIDATED_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const getEnergyConsumptionAction = () => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.GET_ENERGY_CONSUMPTION_REQUEST });

    try {
      const response = await ApiList.getEnergyConsumption();
      if (response) {
        dispatch({
          type: types.GET_ENERGY_CONSUMPTION_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({ type: types.GET_ENERGY_CONSUMPTION_ERROR, payload: response.status });
      }
    } catch (error) {
      dispatch({
        type: types.GET_ENERGY_CONSUMPTION_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const getNetworkEnergyConsumptionAction = (startDate, endDate, useCache) => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.GET_NETWORK_ENERGY_CONSUMPTION_REQUEST });

    try {
      const response = await ApiList.getNetworkEnergyConsumption();
      //console.log("getNetworkEnergyConsumptionAction", response)

      if (response) {
        dispatch({
          type: types.GET_NETWORK_ENERGY_CONSUMPTION_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({ type: types.GET_NETWORK_ENERGY_CONSUMPTION_ERROR, payload: response.status });
      }
    } catch (error) {
      dispatch({
        type: types.GET_NETWORK_ENERGY_CONSUMPTION_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const getOperationalEfficiencyAction = (startDate, endDate, useCache) => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.GET_OPERATIONAL_EFFICIENCY_REQUEST });

    try {
      const response = await ApiList.getOperationalEfficiency();
      //console.log("getOperationalEfficiencyAction", response)

      if (response) {
        dispatch({
          type: types.GET_OPERATIONAL_EFFICIENCY_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({ type: types.GET_OPERATIONAL_EFFICIENCY_ERROR, payload: response.status });
      }
    } catch (error) {
      dispatch({
        type: types.GET_OPERATIONAL_EFFICIENCY_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const getPredictionFaultAction = () => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.GET_PREDICTION_FAULT_REQUEST });

    try {
      const response = await ApiList.getPredictionFault();
     // console.log("getPredictionFaultAction", response)
      if (response) {
        dispatch({
          type: types.GET_PREDICTION_FAULT_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({ type: types.GET_PREDICTION_FAULT_ERROR, payload: response.status });
      }
    } catch (error) {
      dispatch({
        type: types.GET_PREDICTION_FAULT_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const getInsightsAction = (latitude, longitude) => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.GET_INSIGHTS_REQUEST });

    try {
      const response = await ApiList.getInsights();
      //console.log("getInsightsAction", response)
      if (response) {
        dispatch({
          type: types.GET_INSIGHTS_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({ type: types.GET_INSIGHTS_ERROR, payload: response.status });
      }
    } catch (error) {
      dispatch({
        type: types.GET_INSIGHTS_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

